module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('meta-label', {
    attrs: {
      "disabled": _vm.disabled,
      "has-error": _vm.errors.has(_vm.name),
      "inputId": _vm.id,
      "label": _vm.label,
      "required": _vm.required
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: _vm.rules
      }),
      expression: "{ rules: rules }"
    }],
    ref: "input",
    staticClass: "form-control",
    class: _vm.classes,
    attrs: {
      "type": "text",
      "data-vv-as": _vm.label,
      "disabled": _vm.disabled,
      "id": _vm.id,
      "maxlength": _vm.maxlength,
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.name)),
      expression: "errors.has(name)"
    }],
    staticClass: "help text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.name)))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cda31108","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2
// module chunks = 0